import React, { useRef } from "react";
import { FaArrowRight, FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { BTN_SIZE, Container, H2_SIZE } from "../home/ui";

// Real projects from the portfolio page (src/Pages/ProjectScreen.js). Add more e-commerce stores here as they ship.
const projects = [
  { name: "Monovogue", tags: ["E-commerce", "Fashion"], img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/project-img8.svg", href: "/our-completed-projects/monovouge" },
  { name: "Lookplex", tags: ["Online Booking", "UI/UX Design"], img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/project-img1.svg", href: "/our-completed-projects/lookplex" },
  { name: "3D Gardening", tags: ["Services Website", "UI/UX Design"], img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/project-img3.svg", href: "/our-completed-projects/gardening" },
  { name: "Narayana Home Services", tags: ["Service Platform", "Custom Development"], img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/project-img5.svg", href: "/our-completed-projects/narayana-homes" },
  { name: "HealthOMax", tags: ["Healthcare", "Web Platform"], img: "https://d3vqz9qyn2r1xe.cloudfront.net/imges/project-img6.svg", href: "/our-completed-projects/healthomax-website" },
];

const navBtn =
  "absolute top-[38%] z-10 hidden h-[40px] w-[40px] -translate-y-1/2 items-center justify-center rounded-full border-0 bg-white text-[14px] text-[#3B4A7A] shadow-[0_8px_20px_-10px_rgba(40,60,140,0.45)] transition hover:text-[#1E4DFF] md:inline-flex";

const EcomProjects = () => {
  const track = useRef(null);
  const scroll = (dir) => {
    const el = track.current;
    if (el) el.scrollBy({ left: dir * (el.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section className="bg-white py-[40px] lg:py-[56px]">
      <Container className="max-w-[1320px]">
        <div className="flex flex-col gap-[16px] md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className={`font-bold tracking-tight text-[#0B0D2C] ${H2_SIZE}`}>
              Our Recent Projects
            </h2>
            <p className="mt-[8px] text-[15px] text-slate-600 sm:text-[16px]">
              Take a look at some of the websites and online platforms we&apos;ve built for our clients.
            </p>
          </div>
          <a
            href="/our-completed-projects"
            className={`group inline-flex shrink-0 items-center self-start max-sm:self-center rounded-full bg-gradient-to-r from-[#0EA5FF] via-[#3D5BF6] to-[#8B2CF5] font-medium text-white shadow-[0_14px_30px_-14px_rgba(91,61,245,0.7)] transition hover:brightness-110 md:self-auto ${BTN_SIZE}`}
          >
            View All Projects
            <FaArrowRight className="text-[13px] transition group-hover:translate-x-1" />
          </a>
        </div>

        <div className="relative mt-[28px]">
          <button type="button" aria-label="Previous projects" onClick={() => scroll(-1)} className={`${navBtn} -left-[20px]`}>
            <FaChevronLeft />
          </button>
          <div
            ref={track}
            className="flex snap-x snap-mandatory gap-[18px] overflow-x-auto scroll-smooth pb-[14px] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
          >
            {projects.map((p) => (
              <a
                key={p.name}
                href={p.href}
                className="group w-[78%] shrink-0 snap-start overflow-hidden rounded-[16px] border-[1px] border-solid border-[#EEF1F8] bg-white shadow-[0_12px_30px_-20px_rgba(40,60,140,0.35)] transition hover:-translate-y-1 sm:w-[46%] lg:w-[calc((100%-54px)/4)]"
              >
                <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                  <img
                    src={p.img}
                    alt={`${p.name} website`}
                    loading="lazy"
                    className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-[16px]">
                  <p className="text-[16px] font-semibold text-[#0B0D2C]">{p.name}</p>
                  <div className="mt-[10px] flex flex-wrap gap-[8px]">
                    {p.tags.map((t) => (
                      <span key={t} className="rounded-[6px] bg-[#F1F4FB] px-[10px] py-[4px] text-[12px] text-[#4A5578]">
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </a>
            ))}
          </div>
          <button type="button" aria-label="Next projects" onClick={() => scroll(1)} className={`${navBtn} -right-[20px]`}>
            <FaChevronRight />
          </button>
        </div>
      </Container>
    </section>
  );
};

export default EcomProjects;
